// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2umq2","controls":"styles_controls__1M0-5","charLimit":"styles_charLimit__hlfi9","input":"styles_input__ZKvvl","send":"styles_send__3CD_8"};